<form
  class="chat-input"
  [formGroup]="form"
  (ngSubmit)="send()"
  [attr.aria-label]="'SendMessage' | translate">

  <textarea
    #textareaRef
    class="chat-input__textarea"
    formControlName="message"
    [placeholder]="disabled ? (blockedMessage || (unavailableMessageKey | translate)) : (isSending ? ('AiCounselorWaitingForResponse' | translate) : placeholder)"
    [attr.disabled]="(isSending || isTranscribing) ? true : null"
    aria-label="Message input"
    (keydown)="onKeyDown($event)">
  </textarea>

  @if (isRecording || isTranscribing) {
    <div class="chat-input__recording-overlay" aria-live="assertive" aria-label="Voice recording active">
      <span class="chat-input__recording-dot" aria-hidden="true"></span>
      <div class="chat-input__recording-waves" aria-hidden="true">
        <span class="chat-input__recording-wave-bar"></span>
        <span class="chat-input__recording-wave-bar"></span>
        <span class="chat-input__recording-wave-bar"></span>
        <span class="chat-input__recording-wave-bar"></span>
        <span class="chat-input__recording-wave-bar"></span>
        <span class="chat-input__recording-wave-bar"></span>
        <span class="chat-input__recording-wave-bar"></span>
      </div>
      <span class="chat-input__recording-label">{{ isTranscribing ? 'Transcribing…' : 'Listening…' }}</span>
    </div>
  }

  <div class="chat-input__bottom-row">
    <div class="chat-input__left-group">
      <!-- <button
        class="chat-input__attach"
        type="button"
        [attr.aria-label]="'AttachFile' | translate">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.75 7.5H0.75C0.34 7.5 0 7.16 0 6.75C0 6.34 0.34 6 0.75 6H12.75C13.16 6 13.5 6.34 13.5 6.75C13.5 7.16 13.16 7.5 12.75 7.5Z" fill="black"/>
        <path d="M6.75 13.5C6.34 13.5 6 13.16 6 12.75V0.75C6 0.34 6.34 0 6.75 0C7.16 0 7.5 0.34 7.5 0.75V12.75C7.5 13.16 7.16 13.5 6.75 13.5Z" fill="black"/>
        </svg>

      </button> -->

      <div class="chat-input__char-count" [class.chat-input__char-count--over]="isOverLimit">
        {{ wordCount }}/{{ maxWords }} words
      </div>
    </div>

    <div class="chat-input__actions">
      @if (isRecording) {
        <button
          class="chat-input__voice-cancel"
          type="button"
          (click)="cancelRecording()"
          [attr.aria-label]="'Cancel' | translate">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M1 1L13 13M13 1L1 13" stroke="#717680" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
        <button
          class="chat-input__voice-apply"
          type="button"
          (click)="applyRecording()"
          [attr.aria-label]="'Apply' | translate">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M2.5 7.5L5.5 10.5L11.5 3.5" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      } @else {
        <button
          class="chat-input__mic"
          [class.chat-input__mic--unsupported]="!isSpeechSupported"
          type="button"
          [disabled]="isTranscribing || disabled"
          (click)="toggleSpeech()"
          [title]="!isSpeechSupported ? 'Voice input requires microphone access in this browser' : ''"
          [attr.aria-label]="'VoiceInput' | translate"
          [attr.aria-pressed]="false">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_433_5608" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <path d="M24 0H0V24H24V0Z" fill="white"/>
            </mask>
            <g mask="url(#mask0_433_5608)">
            <path d="M12 19.75C8.28 19.75 5.25 16.72 5.25 13V8C5.25 4.28 8.28 1.25 12 1.25C15.72 1.25 18.75 4.28 18.75 8V13C18.75 16.72 15.72 19.75 12 19.75ZM12 2.75C9.11 2.75 6.75 5.1 6.75 8V13C6.75 15.9 9.11 18.25 12 18.25C14.89 18.25 17.25 15.9 17.25 13V8C17.25 5.1 14.89 2.75 12 2.75Z" fill="#A4A7AE"/>
            <path d="M12 22.75C6.62 22.75 2.25 18.38 2.25 13V11C2.25 10.59 2.59 10.25 3 10.25C3.41 10.25 3.75 10.59 3.75 11V13C3.75 17.55 7.45 21.25 12 21.25C16.55 21.25 20.25 17.55 20.25 13V11C20.25 10.59 20.59 10.25 21 10.25C21.41 10.25 21.75 10.59 21.75 11V13C21.75 18.38 17.38 22.75 12 22.75Z" fill="#A4A7AE"/>
            <path d="M14.6101 8.22988C14.5301 8.22988 14.4401 8.21988 14.3501 8.18988C12.7401 7.60988 10.9701 7.60988 9.36012 8.18988C8.98012 8.32988 8.55012 8.12988 8.41012 7.73988C8.27012 7.34988 8.47012 6.91988 8.86012 6.77988C10.8001 6.07988 12.9301 6.07988 14.8701 6.77988C15.2601 6.91988 15.4601 7.34988 15.3201 7.73988C15.2101 8.04988 14.9201 8.22988 14.6101 8.22988Z" fill="#A4A7AE"/>
            <path d="M13.6999 11.2305C13.6399 11.2305 13.5699 11.2205 13.4999 11.2005C12.4299 10.9105 11.2999 10.9105 10.2299 11.2005C9.81992 11.3105 9.41992 11.0705 9.30992 10.6705C9.19992 10.2705 9.43992 9.86047 9.83992 9.75047C11.1699 9.39047 12.5699 9.39047 13.8999 9.75047C14.2999 9.86047 14.5399 10.2705 14.4299 10.6705C14.3299 11.0205 14.0299 11.2305 13.6999 11.2305Z" fill="#A4A7AE"/>
            </g>
          </svg>
        </button>
      }

      <button
        class="chat-input__send"
        type="submit"
        [disabled]="form.invalid || isSending || disabled"
        [attr.aria-label]="'SendMessage' | translate">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M8 12V4M4 8l4-4 4 4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </div>
</form>
